module.exports = __webpack_public_path__ + "static/img/Lalor.c65dd30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lalor.jpg
// module id = hhk0
// module chunks = 0